<template>
  <div class="loading">
    <div class="loading__title">Что изменилось?</div>
    <div class="loading__bar">
      <div class="loading__grad"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped lang="stylus">
.loading
  position: relative
  width: 100%
  padding: 7rem 5rem 0 5rem

.loading__title
  font-weight: 500
  padding-bottom: 3.2rem
  font-size: 2.4rem
  text-align: center

.loading__bar
  height: 2rem
  width: 100%
  max-width: 50rem
  background: #e4e4e4
  margin: 0 auto
  border-radius: 20px
  position: relative

.loading__grad
  height: 1.6rem
  position: absolute
  left: 0.5%
  top: 0.2rem
  background: linear-gradient(to right, #D00240 0%, #2E4EA4 100%)
  border-radius: 20px
  width: 0%

  .is-loading-animated &
    animation: fill 1s
    animation-fill-mode: forwards

@keyframes fill {
  0% {
    width: 0.5%;
  }
  100% {
    width: 99%;
  }
}

</style>
